import React from 'react';


function Homebody2() {
  return (
    <div>
      <section className="content-features bg-dark padding-bottom">
        <div className="bg-half" />
        <div className="map-pattern" />
        <div className="container">
          <div className="counter-wrap">
            <div className="counter-item wow fade-in-bottom" data-wow-delay="200ms">
              <div className="counter-icon">
                <i className="fa fa-briefcase" />
              </div>
              <div className="counter-content">
                <h3><span className="odometer" data-count={25}>00</span></h3>
                <h4>Projects Completed</h4>
              </div>
            </div>
            <div className="counter-item wow fade-in-bottom" data-wow-delay="400ms">
              <div className="counter-icon">
                <i className="fa fa-user" />
              </div>
              <div className="counter-content">
                <h3><span className="odometer" data-count={15}>00</span></h3>
                <h4>Expert Developers</h4>
              </div>
            </div>
            <div className="counter-item wow fade-in-bottom" data-wow-delay="600ms">
              <div className="counter-icon">
                <i className="fa fa-globe" />
              </div>
              <div className="counter-content">
                <h3><span className="odometer" data-count={15}>00</span></h3>
                <h4>Clients Worldwide</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="section-heading white mb-40">

                <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}>What Makes Us <span className="hl">Different? </span></h2>
                <ul className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out" style={{ listStyleType: 'disc', paddingLeft: '20px', color: '#DDDDDD' }}>
                  <li>Integrated IT Services: A one-stop destination for <span style={{ color: '#fff', fontWeight: 'bold' }}>IT Training, staffing</span>, and <span style={{ color: '#fff', fontWeight: 'bold' }}>project management</span>.</li>
                  <li>Client-Centric Approach: Customized solutions that align with your goals.</li>
                  <li>Global Expertise: With a presence across multiple regions, we deliver solutions tailored for diverse industries.</li>
                  <li>Future-Ready Solutions: Leveraging the latest technologies to stay ahead of the curve.</li>
                </ul>
              </div>
              <ul className="promo-list white mb-30">
                <li className="wow fade-in-bottom" data-wow-delay="100ms">
                  <i className="fa fa-trophy" />
                  <div className="promo-content">
                    <h3>Your Success, Our Mission </h3>
                    <p> We believe in creating meaningful solutions that bridge the gap between talent, technology, and transformation. Whether you’re a professional aiming to upskill, a company building a dynamic workforce, or an organization driving impactful projects, <span style={{ color: 'fff', fontWeight: 'bold' }}>TITA Technologies</span> is here to make it happen. </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="col-lg-6 position-relative">
              <div className="feature-tab wow fade-in-bottom" data-wow-delay="200ms">
                <nav className="feature-tab-nav">
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Expert Developers</button>
                    <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false"> Software Solutions </button>
                  </div>
                </nav>
                <div className="tab-content" id="nav-tabContent">
                  <div className="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div className="tab-inner">
                      <div className="feature-tab-content">
                        <h3>Expert Developers</h3>
                        <p>Delivering cutting-edge solutions with unparalleled expertise and innovation.</p>
                      </div>
                      <div className="tab-thumb">
                        <img src="assets/img/post-8.png" alt="thumb" />
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div className="tab-inner">
                      <div className="feature-tab-content">
                        <h3>Software Solutions</h3>
                        <p>Transforming digital landscapes with cutting-edge technology and expert innovation.</p>
                      </div>
                      <div className="tab-thumb">
                        <img src="assets/img/post-4.png" alt="thumb" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
export default Homebody2;
